import { TableColumnType } from 'src/types/table';
import { getRowShipperServiceKey } from 'src/utils/shipperServiceFilter';

export const REQUIRED_RETURNS_GRID_COLUMNS = ['ESHOP_RETURN_ID', 'ID', 'STATUS', 'RMA', 'ORDER_SHIPPER'];
export const REQUIRED_RETURNS_GRID_ALL_PROVIDERS_COLUMNS = [...REQUIRED_RETURNS_GRID_COLUMNS, 'ESHOP_KEY'];

export const allColumns: TableColumnType[] = [
    { key: 'ID', label: 'id', type: 'id' },
    { key: 'RMA', label: 'rma', defaultShow: true },
    { key: 'ESHOP_RETURN_ID', label: 'eshopReturnId', defaultShow: true },
    { key: 'SOURCE_SYS', label: 'sourceSystem', type: 'select', selectOption: 'sourceSysCodes' },
    { key: 'CREATED_AT', label: 'createdAt', defaultShow: true, type: 'dateTime' },
    { key: 'RECEIVED_AT', label: 'receivedAt', type: 'dateTime' },
    { key: 'CONFIRMED_AT', label: 'confirmedAt', defaultShow: true, type: 'dateTime' },
    { key: 'CANCELED_AT', label: 'canceledAt', type: 'dateTime' },

    {
        key: 'PARTNER_ORDER_ID',
        label: 'partnerOrderId',
    },
    {
        key: 'DESCRIPTION',
        label: 'returnDescription',
        defaultShow: true,
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    {
        key: 'STATUS',
        label: 'statusOfReturn',
        defaultShow: true,
        type: 'select',
        selectOption: 'returnStatusCodes',
        customRender: true,
        optionStyleFce: true,
    },
    { key: 'NOTE', label: 'note', customStyle: { maxWidth: '190px' }, customStyleHeader: { maxWidth: '190px' } },
    {
        key: 'ESHOP_NOTE',
        label: 'eshopNote',
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    { key: 'TRANSPORT_PAID_BY', label: 'transportPaidBy', type: 'select', selectOption: 'returnStatusCodes' },
    { key: 'SHIPPER', label: 'shipper' },
    { key: 'SHIPPER_SERVICE_CODE', label: 'shipperServiceCode' },
    { key: 'TRACKING_NUMBER', label: 'trackingNumber' },
    {
        key: 'RECIPIENT_NAME',
        label: 'recipientName',
        defaultShow: true,
        customStyle: { maxWidth: '190px' },
        customStyleHeader: { maxWidth: '190px' },
    },
    { key: 'ORDER_ID', label: 'orderId', defaultShow: true, type: 'number' },
    { key: 'ESHOP_ORDER_ID', label: 'eshopOrderId', defaultShow: true },
    { key: 'ORDER_TYPE', label: 'orderType', type: 'select', selectOption: 'orderTypeCodes' },
    { key: 'ORDER_SHIPPER', label: 'orderShipper', type: 'select', selectOption: 'shipperCodes' },
    {
        key: 'ORDER_SHIPPER_SERVICE_CODE',
        label: 'orderShipperService',
        type: 'select',
        selectOption: 'shipperServiceCodes',
        selectOptionKeyFce: (row) => getRowShipperServiceKey(row, 'ORDER_SHIPPER', 'ORDER_SHIPPER_SERVICE_CODE')
    },
    { key: 'ORDER_TRACKING_NUMBER', label: 'orderTrackingNumber' },
];

export const allColumnsWithProvider: TableColumnType[] = [
    {
        key: 'providerName',
        label: 'providerName',
        allwaysShow: true,
        forceFirst: true,
        disableFilter: true,
        disableSort: true,
    },
    ...allColumns,
];

export const extendProductColumns: TableColumnType[] = [
    { key: 'SKU', label: 'productSKU' },
    { key: 'NAME', label: 'productName' },
    { key: 'QUANTITY', label: 'productQuantity' },
    { key: 'RECEIVED', label: 'productReceived' },
    { key: 'RESOLUTION', label: 'productResolution', type: 'select', selectOption: 'returnResolutionCodes' },
    { key: 'SERIAL_NUMBER', label: 'productSerialNumber' },
];
